// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tyrantrum: PokeData = {
  "id": 697,
  "name": "tyrantrum",
  "height": 25,
  "weight": 2700,
  "base_experience": 182,
  "types": [
    PokeType.ROCK,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "horn-drill",
    "tackle",
    "thrash",
    "tail-whip",
    "bite",
    "roar",
    "earthquake",
    "bide",
    "rock-slide",
    "charm",
    "crunch",
    "ancient-power",
    "dragon-claw",
    "giga-impact",
    "stealth-rock",
    "head-smash",
    "dragon-tail"
  ],
  "moves": [
    "tackle",
    "bite",
    "earthquake",
    "rock-slide",
    "crunch",
    "ancient-power",
    "dragon-claw",
    "stealth-rock",
    "power-siphon",
    "draco-meteor",
    "stone-axe",
    "dragon-breath",
    "dragon-pulse"
  ],
  "evolution_chain": {
    "id": 357,
    "item": null,
    "species": [
      {
        "name": "tyrunt",
        "order": 697,
        "types": [
          PokeType.ROCK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "tyrantrum",
        "order": 698,
        "types": [
          PokeType.ROCK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 696,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 102,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
